import { render, staticRenderFns } from "./ed-folder-item-progress.component.vue?vue&type=template&id=115752f2&scoped=true&"
import script from "./ed-folder-item-progress.component.ts?vue&type=script&lang=ts&"
export * from "./ed-folder-item-progress.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-folder-item-progress.component.scss?vue&type=style&index=0&id=115752f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115752f2",
  null
  
)

export default component.exports